module.exports = __webpack_public_path__ + "img/skip-button.d4aaac4a.png";